const releasesValidationPT = {
    "add": {
        "releaseName": {
            "required": 'O nome do lançamento é obrigatório',
            "length": 'O nome do lançamento deve ter mais de 2 e menos de 120 caracteres',
            "noForwardSlash": 'O nome do lançamento não deve conter barra (/)',
            "matchTrack": 'Para um lançamento de uma música, o nome do lançamento deve coincidir com a faixa.',
            // validCharacters: 'O nome do lançamento pode consistir apenas em letras, números, espaços e sublinhados'
            },
            "releaseVersion": {
                "length": 'A versão do lançamento deve ter mais de 2 e menos de 120 caracteres',
                "validCharacters": 'A versão do lançamento pode consistir apenas em letras, números, espaços e sublinhados',
                "missingOne": 'Seu lançamento consiste em apenas uma faixa que não é uma Mix Original, portanto, o nome da mixagem personalizada deve ser inserido na Versão do Lançamento.',
                "missingTwo": 'Se um lançamento oferece mais conteúdo que a versão padrão ou é outra versão de um álbum/lançamento já lançado, você precisa inserir a Versão do Lançamento.',
                "invalid": 'Para um lançamento de uma música sem Nome de Mixagem (Mixagem Original), a Versão do Lançamento deve ser deixada em branco. Por favor, limpe a Versão do Lançamento ou adicione um Nome de Mixagem à música.'
            },
            "releaseLanguage": {
                "required": 'O idioma do lançamento é obrigatório. Por favor, selecione o idioma do nome do seu lançamento.'
            },
            "releaseEAN_UPC": {
                "required": "EAN / UPC é obrigatório.",
                "length": "O número EAN deve ter exatamente 13 caracteres.",
                "isValidEAN": "O valor não é um EAN válido. Se estiver inserindo um novo lançamento, por favor insira um EAN correto. Se estiver carregando um catálogo anterior e o EAN for inválido, entre em contato conosco."
            },
            "releaseLabel": {
                "required": 'Por favor, selecione seu selo.'
            },
            "releaseCopyright": {
                "required": 'Você deve digitar o Proprietário dos Direitos Autorais. Normalmente é seu selo.'
            },
            "releaseCopyrightYear": {
                "required": 'Por favor, digite o ano dos direitos autorais em que este lançamento será (foi) publicado.',
                "regexp": 'Por favor, digite um ano de direitos autorais válido'
            },
            "releaseCopyrightPublisher": {
                "required": 'Você deve digitar o Proprietário da Editora. Normalmente é seu selo.'
            },
            "releaseCopyrightYearPublisher": {
                "required": 'Por favor, digite o ano dos direitos autorais em que este lançamento será (foi) publicado.',
                "regexp": 'Por favor, digite um ano de direitos autorais válido'
            },
            "releaseGenre": {
                "required": 'Por favor, selecione o Gênero do seu lançamento.'
            },
            "releaseSubGenre": {
                "required": 'Por favor, selecione o Subgênero do seu lançamento'
            },
            "releaseCatalogNumber": {
                "required": 'Insira um número de catálogo de lançamento único.',
                "length": 'Mínimo de 4 e máximo de 16 caracteres.',
                "validFormat": 'Por favor, insira seu número de categoria sem espaços, apenas letras MAIÚSCULAS e números. Os dois primeiros caracteres devem ser letras MAIÚSCULAS. MM001, MMD001, MM0001 ... '
            },
            "releaseDescription": {
                // required: 'Uma boa e profissional descrição do lançamento pode fazer a diferença.',
                "length": 'A descrição do lançamento deve ter pelo menos 100 e no máximo 600 caracteres.'
            },
            "releaseArtwork": {
                "required": 'A arte é obrigatória',
                "wrongSpecsAndColor": 'Especificações de imagem e formato de cor incorretos. O tamanho da capa do lançamento deve ser exatamente 3000 x 3000 px, Cores RGB, JPG, tamanho máximo do arquivo 4 MB.',
                "wrongColorFormat": 'Formato de cor da imagem incorreto. A capa do lançamento deve estar em Cores RGB. JPG, tamanho máximo do arquivo 4 MB.',
                "wrongSpecs": 'Especificações de imagem incorretas. O tamanho da capa do lançamento deve ser exatamente 3000 x 3000 px. JPG, tamanho máximo do arquivo 4 MB.',
                "meetsSpecs": 'A imagem atende a todas as especificações.',
                "chooseImage": 'Por favor, escolha uma imagem',
                "fileTooLarge": 'O arquivo selecionado é maior que 4 MB. Por favor, carregue a capa em 3000x3000 px, JPG, cores RGB, tamanho máximo do arquivo 4 MB',
                "wrongExtension": 'Extensão de arquivo incorreta. O arquivo selecionado tem extensão ".jpeg". Por favor, carregue a capa em 3000x3000 px, JPG (apenas extensão ".jpg"), cores RGB, tamanho máximo do arquivo 4 MB'
            },
            "releaseTerritories": {
                "required": 'Por favor, selecione territórios.'
            },
            "atleastOneCountrySelected": {
                "required": 'Por favor, selecione pelo menos um país.'
            },
            "atleastOneContentIDChoiceSelected": {
                "required": 'A declaração do ID de Conteúdo do Youtube é obrigatória, por favor, selecione uma das opções acima.'
            },
            "originalReleaseDate": {
                "required": 'Por favor, selecione a data de lançamento original para todas as lojas no mundo.'
            },
            "officialReleaseDate": {
                "required": 'Por favor, selecione a data de lançamento oficial para todas as lojas no mundo.'
            },
            "atleastOneMainArtist": {
                "required": 'Pelo menos um artista deve ser principal'
            },
            "featuringArtistMissing": {
                "required": 'O lançamento deve ter o artista em destaque listado no título corretamente atribuído ao papel de artista em destaque. Por favor, corrija e envie novamente.'
            },
            "duplicateArtists": {
                "required": 'Existem dois ou mais artistas com o mesmo nome.'
            },
            "artistName": {
                "required": 'Por favor, selecione o artista'
            },
            "artistType": {
                "required": 'Por favor, selecione o tipo de artista'
            },
            "trackName": {
                "required": 'Por favor, digite o nome da faixa'
            },
            "trackMixName": {
                "required": 'Por favor, digite o nome da mixagem',
                "regexp": 'O nome da mixagem pode consistir apenas em letras, números, espaços e sublinhados'
            }
    },
    "update": {
        "releaseName": {
            "required": 'O nome do lançamento é obrigatório',
            "length": 'O nome do lançamento deve ter mais de 2 e menos de 120 caracteres',
            "noForwardSlash": 'O nome do lançamento não deve conter barra (/)',
            "matchTrack": 'Para um lançamento de uma música, o nome do lançamento deve coincidir com a faixa.',
            "validCharacters": 'O nome do lançamento pode consistir apenas em letras, números, espaços e sublinhados'
        },
        "releaseVersion": {
            "length": 'A versão do lançamento deve ter mais de 2 e menos de 120 caracteres',
            "validCharacters": 'A versão do lançamento pode consistir apenas em letras, números, espaços e sublinhados',
            "missingOne": 'Seu lançamento consiste em apenas uma faixa que não é uma Mix Original, portanto, o nome da mixagem personalizada deve ser inserido na Versão do Lançamento.',
            "missingTwo": 'Se um lançamento oferece mais conteúdo que a versão padrão ou é outra versão de um álbum/lançamento já lançado, você precisa inserir a Versão do Lançamento.',
            "invalid": 'Para um lançamento de uma música sem Nome de Mixagem (Mixagem Original), a Versão do Lançamento deve ser deixada em branco. Por favor, limpe a Versão do Lançamento ou adicione um Nome de Mixagem à música.'
        },
        "releaseLanguage": {
            "required": 'O idioma do lançamento é obrigatório. Por favor, selecione o idioma do nome do seu lançamento.'
        },
        "releaseEAN_UPC": {
            "required": "EAN / UPC é obrigatório.",
            "length": "O número EAN deve ter exatamente 13 caracteres.",
            "isValidEAN": "O valor não é um EAN válido. Se estiver inserindo um novo lançamento, por favor insira um EAN correto. Se estiver carregando um catálogo anterior e o EAN for inválido, entre em contato conosco."
        },
        "releaseLabel": {
            "required": 'Por favor, selecione seu selo.'
        },
        "releaseCopyright": {
            "required": 'Você deve selecionar o Proprietário dos Direitos Autorais. Normalmente é seu selo.'
        },
        "releaseCopyrightYear": {
            "required": 'Por favor, digite o ano dos direitos autorais em que este lançamento será (foi) publicado.',
            "regexp": 'Por favor, digite um ano de direitos autorais válido'
        },
        "releaseCopyrightPublisher": {
            "required": 'Você deve digitar o Proprietário da Editora. Normalmente é seu selo.'
        },
        "releaseCopyrightYearPublisher": {
            "required": 'Por favor, digite o ano dos direitos autorais em que este lançamento será (foi) publicado.',
            "regexp": 'Por favor, digite um ano de direitos autorais válido'
        },
        "releaseGenre": {
            "required": 'Por favor, selecione o Gênero do seu lançamento.'
        },
        "releaseSubGenre": {
            "required": 'Por favor, selecione o Subgênero do seu lançamento'
        },
        "releaseCatalogNumber": {
            "required": 'Insira um número de catálogo de lançamento único.',
            "length": 'Mínimo de 4 e máximo de 16 caracteres.',
            "validFormat": 'Por favor, insira seu número de categoria sem espaços, apenas letras MAIÚSCULAS e números. Os dois primeiros caracteres devem ser letras MAIÚSCULAS. MM001, MMD001, MM0001 ...'
        },
        "releaseDescription": {
            "length": 'A descrição do lançamento deve ter pelo menos 100 e no máximo 600 caracteres.'
        },
        "releaseArtwork": {
            "required": 'A arte é obrigatória',
            "wrongSpecsAndColor": 'Especificações de imagem e formato de cor incorretos. O tamanho da capa do lançamento deve ser exatamente 3000 x 3000 px, Cores RGB, JPG, tamanho máximo do arquivo 4 MB.',
            "wrongColorFormat": 'Formato de cor da imagem incorreto. A capa do lançamento deve estar em Cores RGB. JPG, tamanho máximo do arquivo 4 MB.',
            "wrongSpecs": 'Especificações de imagem incorretas. O tamanho da capa do lançamento deve ser exatamente 3000 x 3000 px. JPG, tamanho máximo do arquivo 4 MB.',
            "meetsSpecs": 'A imagem atende a todas as especificações.',
            "chooseImage": 'Por favor, escolha uma imagem',
            "fileTooLarge": 'O arquivo selecionado é maior que 4 MB. Por favor, carregue a capa em 3000x3000 px, JPG, cores RGB, tamanho máximo do arquivo 4 MB',
            "wrongExtension": 'Extensão de arquivo incorreta. O arquivo selecionado tem extensão ".jpeg". Por favor, carregue a capa em 3000x3000 px, JPG (apenas extensão ".jpg"), cores RGB, tamanho máximo do arquivo 4 MB'
        },
        "releaseTerritories": {
            "required": 'Por favor, selecione territórios.'
        },
        "atleastOneCountrySelected": {
            "required": 'Por favor, selecione pelo menos um país.'
        },
        "atleastOneContentIDChoiceSelected": {
            "required": 'A declaração do ID de Conteúdo do Youtube é obrigatória, por favor, selecione uma das opções acima.'
        },
        "originalReleaseDate": {
            "required": 'Por favor, selecione a data de lançamento original para todas as lojas no mundo.'
        },
        "officialReleaseDate": {
            "required": 'Por favor, selecione a data de lançamento oficial para todas as lojas no mundo.'
        },
        "atleastOneMainArtist": {
            "required": 'Pelo menos um artista deve ser principal'
        },
        "featuringArtistMissing": {
            "required": 'O lançamento deve ter o artista em destaque listado no título corretamente atribuído ao papel de artista em destaque. Por favor, corrija e envie novamente.'
        },
        "duplicateArtists": {
            "required": 'Existem dois ou mais artistas com o mesmo nome.'
        },
        "artistName": {
            "required": 'Por favor, selecione o artista'
        },
        "artistType": {
            "required": 'Por favor, selecione o tipo de artista'
        },
        "trackName": {
            "required": 'Por favor, digite o nome da faixa'
        },
        "trackMixName": {
            "required": 'Por favor, digite o nome da mixagem',
            "regexp": 'O nome da mixagem pode consistir apenas em letras, números, espaços e sublinhados'
        }
    },
    "transfer": {
        "releaseName": {
            "required": "O nome do lançamento é obrigatório",
            "length": "O nome do lançamento deve ter entre 2 e 120 caracteres",
            "invalid": "O nome do lançamento não pode conter uma barra (/)"
        },
        "releaseVersion": {
            "length": "A versão do lançamento deve ter mais de 2 e menos de 120 caracteres",
            "regexp": "A versão do lançamento pode consistir apenas em letras, números, espaços e sublinhados",
            "missingOne": "Seu lançamento consiste em apenas uma faixa que não é uma Mix Original, portanto, o nome da mixagem personalizada deve ser inserido na Versão do Lançamento.",
            "missingTwo": "Se um lançamento oferece mais conteúdo que a versão padrão ou é outra versão de um álbum/lançamento já lançado, você precisa inserir a Versão do Lançamento.",
            "invalid": "Para um lançamento de uma música sem Nome de Mixagem (Mixagem Original), a Versão do Lançamento deve ser deixada em branco. Por favor, limpe a Versão do Lançamento ou adicione um Nome de Mixagem à música."
        },
        "releaseLanguage": {
            "required": "O idioma do lançamento é obrigatório. Por favor, selecione o idioma do nome do seu lançamento."
        },
        "releaseLabel": {
            "required": "Por favor, selecione seu selo."
        },
        "releaseCopyright": {
            "required": "Você deve digitar o Proprietário dos Direitos Autorais. Normalmente é seu selo."
        },
        "releaseCopyrightYear": {
            "required": "Por favor, digite o ano dos direitos autorais em que este lançamento será (foi) publicado.",
            "regexp": "Por favor, digite um ano de direitos autorais válido"
        },
        "releaseCopyrightPublisher": {
            "required": "Você deve digitar o Proprietário da Editora. Normalmente é seu selo."
        },
        "releaseCopyrightYearPublisher": {
            "required": "Por favor, digite o ano dos direitos autorais em que este lançamento será (foi) publicado.",
            "regexp": "Por favor, digite um ano de direitos autorais válido"
        },
        "releaseGenre": {
            "required": "Por favor, selecione o Gênero do seu lançamento."
        },
        "releaseSubGenre": {
            "required": "Por favor, selecione o Subgênero do seu lançamento."
        },
        "releaseCatalogNumber": {
            "required": "Insira um número de catálogo de lançamento único.",
            "length": "Mínimo de 4 e máximo de 16 caracteres.",
            "regexp": "Por favor, insira seu número de categoria sem espaços, apenas letras MAIÚSCULAS e números. Os dois primeiros caracteres devem ser letras MAIÚSCULAS. MM001, MMD001, MM0001 ... "
        },
        "releaseDescription": {
            "length": "A descrição do lançamento deve ter pelo menos 100 e no máximo 600 caracteres."
        },
        "releaseArtwork": {
            "required": "A arte é obrigatória",
            "invalidDimensionsAndColorFormat": "Especificações de imagem e formato de cor incorretos. O tamanho da capa do lançamento deve ser exatamente 3000 x 3000 px, Cores RGB, JPG, tamanho máximo do arquivo 4 MB.",
            "invalidColorFormat": "Formato de cor da imagem incorreto. A capa do lançamento deve estar em Cores RGB. JPG, tamanho máximo do arquivo 4 MB.",
            "invalidDimensions": "Especificações de imagem incorretas. O tamanho da capa do lançamento deve ser exatamente 3000 x 3000 px. JPG, tamanho máximo do arquivo 4 MB.",
            "valid": "A imagem atende a todas as especificações",
            "choose": "Por favor, escolha uma imagem",
            "fileSize": "O arquivo selecionado é maior que 4 MB. Por favor, carregue a capa em 3000x3000 px, JPG, cores RGB, tamanho máximo do arquivo 4 MB",
            "fileExtension": "Extensão de arquivo incorreta. O arquivo selecionado tem extensão '.jpeg'. Por favor, carregue a capa em 3000x3000 px, JPG (apenas extensão '.jpg'), cores RGB, tamanho máximo do arquivo 4 MB'"
        },
        "releaseTerritories": {
            "required": "Por favor, selecione territórios."
        },
        "atleastOneCountrySelected": {
            "required": "Por favor, selecione pelo menos um país."
        },
        "atleastOneContentIDChoiceSelected": {
            "required": "A declaração do ID de Conteúdo do Youtube é obrigatória, por favor, selecione uma das opções acima."
        },
        "originalReleaseDate": {
            "required": "Por favor, selecione a data de lançamento original para todas as lojas no mundo."
        },
        "officialReleaseDate": {
            "required": "Por favor, selecione a data de lançamento oficial para todas as lojas no mundo."
        },
        "atleastOneMainArtist": {
            "required": "Pelo menos um artista deve ser principal"
        },
        "artistType": {
            "required": "Por favor, selecione o tipo de artista"
        },
        "trackName": {
            "required": "Por favor, digite o nome da faixa"
        },
        "trackMixName": {
            "required": "Por favor, digite o nome da mixagem",
            "regexp": "O nome da mixagem pode consistir apenas em letras, números, espaços e sublinhados"
        }
    }
};

export default releasesValidationPT;